import { ErrorAPI } from 'api/Assessor/methods';
import { AxiosError } from 'axios';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import {
  getAssembleiasNotificacaoEndpoint,
  getSocketTechToUse,
  getSSEAssembleiasEndpoint,
  getWSAssembleiasEndpoint,
} from 'library/Apis';
import { Dispatch } from 'redux';
import ApiService from 'services/ApiService';
import { IReducer } from 'store/Reducer';
import {
  getMergedParamsFromObject,
  toRequest,
} from 'helpers/utils/RequestUtils';
import { assembleiaAssessorActionsRefresh } from './AssembleiasAssessorActions';
import { AssembleiasAssessorActionTypes } from './AssembleiasAssessorActionTypes';
import { assembleiaAssociadoActionsRefresh } from './AssembleiasAssociadoActions';
import { AssembleiasAssociadoActionTypes } from './AssembleiasAssociadoActionTypes';
import { IAssessorAction } from './assessor/interfaces';
//import CryptoJS from 'crypto-js';
import { IAssociadoAction } from './associado/interfaces';
import {
  WS_ASSEMBLEIAS_ACTIONS_CLOSE,
  WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH,
  WS_ASSEMBLEIAS_ACTIONS_ON_ERROR,
  WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE,
  WS_ASSEMBLEIAS_ACTIONS_OPEN,
  WSAssembleiasActionTypes,
} from './WSAssembleiasActionTypes';
import { IWSAssembleia } from './WSAssembleiasReducer';

export const WS_ASSEMBLEIAS_ACTION_DEFAULT_USUARIOS_ONLINE: number = -1;

export const wsAssembleiasActionsSendMessage = (
  wsAssembleia: IWSAssembleia | any,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI> | null) => void
) => {
  return (
    dispatch: Dispatch<WSAssembleiasActionTypes>,
    getState: () => IReducer
  ) => {
    const usuario = getState().auth.usuario;
    const authorization = usuario
      ? usuario!.associadoAccessToken || usuario.ldapAccessToken
      : null;
    new Promise(
      (
        resolve: (e?: any) => void,
        reject: (error: AxiosError<ErrorAPI> | null) => void
      ) => {
        if (!authorization) {
          reject(null);
        } else {
          toRequest(
            ApiService.post,
            [
              `${getAssembleiasNotificacaoEndpoint()}assembleia?authorization=${authorization}`,
              wsAssembleia,
            ],
            'assembleiasAssociadoActionsLoadContas'
          ).then(
            () => {
              resolve();
            },
            (error: AxiosError<ErrorAPI>) => {
              reject(error);
            }
          );
        }
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error: AxiosError<ErrorAPI> | null) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

// Variaveis apenas para o WebSocket
const wsPingTimeInSeconds = 10;
let wsInterval: number | undefined;

const showLog = false;
let tech: WebSocket | EventSource | undefined;

const LOG = (...message: any) => {
  if (showLog) {
    return console.log(...message);
  }
};

export const wsAssembleiasActionsManualRefresh = (dispatch: any) => {
  dispatch({
    type: WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH,
  });
};

export const wsAssembleiasActionsClose = () => {
  return (dispatch: any) => {
    if (tech instanceof WebSocket) {
      LOG('Closing WebSocket!');
      tech?.close();
    } else if (tech instanceof EventSource) {
      LOG('Closing SSE!');
      tech?.close();
      tech = undefined;
    }
    dispatch({
      type: WS_ASSEMBLEIAS_ACTIONS_CLOSE,
    });
  };
};

const WS_STORAGE = 'ws_currentEvent';

export const setCurrentWSEvent = (idEvento: number) => {
  sessionStorage.setItem(WS_STORAGE, idEvento.toString());
};

export const getCurrentWSEvent = () => {
  const idEventoString = sessionStorage.getItem(WS_STORAGE);
  return idEventoString ? parseInt(idEventoString) : null;
};

export const wsAssembleiasActionsOpen = (
  authorization: string,
  cpf: string | number,
  idEvento: number,
  isConvidado: boolean,
  statusAssembleia: AssembleiaStatus,
  callbackSuccess?: (event?: Event) => void,
  callbackError?: (error?: Event) => void,
  callbackClosed?: (event?: CloseEvent) => void
) => {
  return (
    dispatch: Dispatch<
      | WSAssembleiasActionTypes
      | AssembleiasAssessorActionTypes
      | AssembleiasAssociadoActionTypes
      | IAssessorAction
      | IAssociadoAction
    >,
    getState: () => IReducer
  ) => {
    const sendMessage = () => {
      if (tech instanceof WebSocket) {
        LOG('PING');
        tech.send('ping');
      }
    };

    const dispatchOpened = (event: Event) => {
      wsInterval =
        tech instanceof WebSocket
          ? window.setInterval(() => {
              sendMessage();
            }, 1000 * wsPingTimeInSeconds)
          : undefined;

      LOG(tech instanceof WebSocket ? 'WebSocket' : 'SSE', ' opened');

      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_OPEN,
      });
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(event);
      }
    };

    const dispatchError = (event: Event) => {
      LOG(tech instanceof WebSocket ? 'WebSocket error' : 'SSE error', event);

      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_ON_ERROR,
        payload: event,
      });

      if (typeof callbackError === 'function') {
        callbackError(event);
      }
    };

    const dispatchOnMessage = (event: MessageEvent) => {
      //const receive = JSON.parse(event.data) as ReceiveWS;
      //const message = receive.message;
      //     CryptoJS.AES.decrypt({
      //       ciphertext: CryptoJS.enc.Base64.parse(receive.message),
      //     } as CryptoJS.lib.CipherParams,
      //     // CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY!),
      //     CryptoJS.enc.Utf8.parse("fb2d0a5f9f8177cc23f557ab993de95d"),
      //     {
      //       mode: CryptoJS.mode.CBC as any,
      //       padding: CryptoJS.pad.Pkcs7,
      //       iv: CryptoJS.enc.Utf8.parse("SSEMessage"),
      //       // iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_IV!),
      //     }
      //
      // ).toString(CryptoJS.enc.Utf8);
      LOG(
        `${tech instanceof WebSocket ? 'WebSocket' : 'SSE'} - Nova Mensagem`,
        event.data
      );
      if (!event || !event.data) return;
      const data = JSON.parse(event.data);
      const payload = (
        typeof data === 'string' ? JSON.parse(data) : data
      ) as IWSAssembleia;

      if (payload.id) {
        dispatch({
          type: WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE,
          payload,
        });
        dispatch(assembleiaAssociadoActionsRefresh(payload));
        dispatch(assembleiaAssessorActionsRefresh(payload));

        if (payload.usuariosLogados && payload.id === idEvento) {
          dispatch({
            type: 'setUsuariosOnline',
            payload: payload.usuariosLogados,
          });
        }

        if (payload.pautas && payload.pautas.length > 0) {
          const currentEvent = getState().assembleiasAssessor?.evento?.id;
          if (idEvento !== currentEvent) return;
          const _pautas = Array.from(getState().assessor.pautas!.elements);
          const targets = payload.pautas.map((pauta) => pauta.idPauta);
          _pautas.forEach((pauta, idx) => {
            if (targets.includes(pauta.idPauta)) {
              let change = payload.pautas.find(
                (item) => item.idPauta === pauta.idPauta
              );
              _pautas[idx] = Object.assign(
                {},
                pauta,
                change
                  ? {
                      status:
                        change.status !== null
                          ? change.status
                          : _pautas[idx].status,
                      statusPresencial:
                        change.statusPresencial !== null
                          ? change.statusPresencial
                          : _pautas[idx].statusPresencial,
                      tempoVotacao:
                        change.tempoVotacao !== null
                          ? change.tempoVotacao
                          : _pautas[idx].tempoVotacao,
                      tempoRestante:
                        change.tempoRestante !== null
                          ? change.tempoRestante
                          : _pautas[idx].tempoRestante,
                      resultadoLiberado:
                        change.resultadoLiberado !== null
                          ? change.resultadoLiberado
                          : _pautas[idx].resultadoLiberado,
                      resultadoLiberadoAssociado:
                        change.resultadoLiberadoAssociado !== null
                          ? change.resultadoLiberadoAssociado
                          : _pautas[idx].resultadoLiberadoAssociado,
                      resultadoLiberadoPresencial:
                        change.resultadoLiberadoPresencial !== null
                          ? change.resultadoLiberadoPresencial
                          : _pautas[idx].resultadoLiberadoPresencial,
                    }
                  : undefined
              );
            }
          });
          dispatch({
            type: 'setPautas',
            payload: {
              ...getState().assessor.pautas!,
              elements: _pautas,
            },
          });
        }

        // Atualizar página de Liberação de Pautas em lote
        if (
          payload.needLoadPautas ||
          (payload.pautas && payload.pautas.length)
        ) {
          dispatch({
            type: 'countRecebemosPautasNovas',
          });
        }
      }
    };

    // Somente Websocket
    const dispatchClosed = (event: CloseEvent) => {
      window.clearInterval(wsInterval);
      tech = undefined;
      LOG('WebSocket Fechado', event);
      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_CLOSE,
      });
      if (typeof callbackClosed === 'function') {
        callbackClosed(event);
      }
    };

    if (!tech) {
      const techToUse: 'wsAssembleia' | 'sseAssembleia' | '' =
        getSocketTechToUse();
      const params = {
        authorization,
        statusAssembleia,
      } as any;
      if (techToUse === 'wsAssembleia') {
        params.idEvento = idEvento;
        params.cpf = cpf;
        params.isConvidado = isConvidado;
        const url = `${getWSAssembleiasEndpoint()}?${getMergedParamsFromObject(
          params
        )}`;
        tech = new WebSocket(url);
        LOG('Iniciando WebSocket');
      } else if (techToUse === 'sseAssembleia') {
        params.convidado = isConvidado;
        const url = `${getSSEAssembleiasEndpoint()}${idEvento.toString()}?${getMergedParamsFromObject(
          params
        )}`;
        tech = new EventSource(url);
        LOG('Iniciando SSE');
      }

      if (tech) {
        tech!.onopen = dispatchOpened;
        tech!.onerror = dispatchError;
        tech!.onmessage = dispatchOnMessage;
        if (tech instanceof WebSocket) {
          tech!.onclose = dispatchClosed;
        }
      }
    }
  };
};
